import AirplaneIcon from '@mui/icons-material/AirplanemodeActive';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { Form, useNavigation } from '@remix-run/react';

export function ApproveModal({
  open,
  onClose,
  productIds,
}: {
  open: boolean;
  onClose: () => void;
  productIds: number[];
}) {
  const navigation = useNavigation();
  const disabled = navigation.state !== 'idle';

  function handleClose() {
    if (disabled) return;
    onClose();
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      sx={{
        zIndex: 1301,
        '& .MuiDialog-paper ': {
          position: 'relative',
          maxWidth: 520,
          py: 3,
          px: 2,
          '& > *': { p: 0 },
          '& > :first-of-type': { pb: 3 },
          '& > :last-of-type': { pt: 3 },
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Stack direction="row" alignItems="center" mb={3}>
          <Stack bgcolor="#F0F5F9" borderRadius="50%" sx={{ p: 1.25 }}>
            <AirplaneIcon color="primary" sx={{ fontSize: 20 }} />
          </Stack>
          <IconButton
            onClick={handleClose}
            disabled={disabled}
            sx={{ p: 0.75, position: 'absolute', top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        Your designs are ready for approval
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        Note that once your designs are submitted and approved, they cannot be modified.
      </DialogContent>
      <DialogActions>
        <Form method="post" style={{ display: 'flex', width: '100%', justifyContent: 'space-between', gap: 3 }}>
          <Button onClick={handleClose} disabled={disabled} sx={{ flex: 1 }}>
            CANCEL
          </Button>
          <input type="hidden" name="productIds" value={productIds.join(',')} />
          <Button
            disabled={disabled}
            type="submit"
            name="_action"
            value="approveDesigns"
            variant="contained"
            sx={{ flex: 1 }}
            disableElevation
          >
            APPROVE DESIGNS
          </Button>
        </Form>
      </DialogActions>
    </Dialog>
  );
}
